import { sendEvent } from '@nubank/www-latam-commons/services/analytics';

export const trackingClickMenu = label => {
  sendEvent('CLICK_MENU', { label: label.toLowerCase() });
};
